import { Box, Container, Grid } from "@mui/material";
import dev2Img from "assets/images/mascots/dev2_avatar.png";
import devImg from "assets/images/mascots/dev_avatar.png";
import colors from "assets/theme/base/colors";
import { CartoonCardAvatar } from "components/CartoonCard";
import SectionDivider from "./SectionDivider";
function Team({ id }) {
  return (
    <Container id={id}>
      <Box py={10}>
        <SectionDivider title=" Meet the Team 👨‍🚀" withDivider />

        <Grid container spacing={3} alignContent={"center"} justifyContent={"center"}>
          <Grid item xs={12} md={4}>
            <CartoonCardAvatar
              name="Pablo"
              role="CEO - Core Flarter"
              color="white"
              backgroundColor={colors.primary.main}
              tilt={true}
              baseTileAngle={0}
              endTiltAngle={-3}
              description="Software expert with 9+ years in app development.
Blockchain developer specializing in smart contracts and tokenization of assets."
              avatar={devImg}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CartoonCardAvatar
              name="Fabio"
              role="CTO - Chief Tooting Officer"
              color="white"
              backgroundColor={colors.secondary.main}
              tilt={true}
              baseTileAngle={0}
              endTiltAngle={-3}
              description="Software expert with 9+ years in web and mobile app development."
              avatar={dev2Img}
            />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default Team;
